import { MoovDefinitionDTO } from "../DTO/moovDefinitionDTO";
import { MicrosoftAppType } from "./moovStepDefinition";
import { MoovStep } from "./moovStep";
import { Preset } from "./preset";

export class MoovDefinition{
    public id? : number;
    public name! : string;
    public description! : string;
    public integratesWith?:string;
    public steps : MoovStep[] = []; //protocol for each field on how to transform
    public version? : number; //incremental version number set by server
    public published : boolean = false; //if true, then can be used for moovs and can be loaded by other users
    public added? : Date;
    public deleted : boolean = false;
    public outdated : boolean = false;
    public ownedByEntityId? : number;
    public ownerEntityType? : string;
    public usageType? : number;
    public integrationType? : number;
    public usagePrice? : number;
    public billingBucketId? : number;
    public presets? : Preset[];
    public wizardSessionId? : number;

    constructor(){
    }

    public static mapFromDTO(param:MoovDefinitionDTO):MoovDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.integratesWith = param.integratesWith;
            obj.steps = param.steps.map(s=>MoovStep.mapFromDTO(s));
            obj.version = param.version;
            obj.published = param.published;
            if(param.added) obj.added = new Date(param.added);
            obj.deleted = param.deleted;
            obj.outdated = param.outdated;
            obj.ownedByEntityId = param.ownedByEntityId;
            obj.ownerEntityType = param.ownerEntityType;
            obj.usageType = param.usageType;
            obj.integrationType = param.integrationType;
            obj.usagePrice = param.usagePrice;
            obj.billingBucketId = param.billingBucketId;
            if(param.presets){
                obj.presets = [];
                let presetArray = JSON.parse(param.presets) as any[];
                obj.presets.push(...presetArray.map(ps => Object.assign(new Preset(), ps)));
            }
            obj.wizardSessionId = param.wizardSessionId;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MoovDefinition):MoovDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.integratesWith = param.integratesWith;
            dto.steps = param.steps.map(mds=>MoovStep.mapToDTO(mds));
            dto.version = param.version;
            dto.published = param.published;
            if(param.added) dto.added = param.added.toISOString();
            dto.deleted = param.deleted;
            dto.outdated = param.outdated;
            dto.ownedByEntityId = param.ownedByEntityId;
            dto.ownerEntityType = param.ownerEntityType;
            dto.usageType = param.usageType;
            dto.integrationType = param.integrationType;
            dto.usagePrice = param.usagePrice;
            dto.billingBucketId = param.billingBucketId;
            if(param.presets) dto.presets = JSON.stringify(param.presets);
            dto.wizardSessionId = param.wizardSessionId;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get status():string{
        return this.deleted?"Inactive":"Active";
    }

    get hasDocumentTriggerStep(){
        return this.steps.findIndex(s=>s.moovStepDefinition.isDocumentTriggerStep)>-1;
    }

    get hasWebhookTriggerStep(){
        return this.steps.findIndex(s=>s.moovStepDefinition.isWebhookTriggerStep)>-1;
    }

    get premierPartnerRestriction(){
          let ms = this.steps.find(ms=>ms.moovStepDefinition.premierPartnerRestriction!=undefined);
          return ms?.moovStepDefinition.premierPartnerRestriction;
    }

    get hasQBOStep(){
        return this.steps.findIndex(s=>s.moovStepDefinition?.isQBOStep)>-1;
    }

    get needsQBOAuthorization(){
        return this.steps.findIndex(s=>s.moovStepDefinition?.needsQBOAuthorization)>-1;
    }

    get hasXeroStep(){
        return this.steps.findIndex(s=>s.moovStepDefinition?.isXeroStep)>-1;
    }

    get needsXeroAuthorization(){
        return this.steps.findIndex(s=>s.moovStepDefinition?.needsXeroAuthorization)>-1;
    }

    get hasDropboxStep(){
        return this.steps.findIndex(s=>s.moovStepDefinition?.isDropboxStep)>-1;
    }

    get needsDropboxAuthorization(){
        return this.steps.findIndex(s=>s.moovStepDefinition?.needsDropboxAuthorization)>-1;
    }

    get hasMicrosoftStep(){
        return this.steps.findIndex(s=>s.moovStepDefinition?.isMicrosoftStep)>-1;
    }

    get needsMicrosoftAuthorization(){
        return this.steps.findIndex(s=>s.moovStepDefinition?.needsMicrosoftAuthorization)>-1;
    }

    //a moov uses only one of the Microsoft apps; undefined if the moov has no Microsoft step
    get microsoftAppType():MicrosoftAppType | undefined{
        return this.steps.find(s=>s.moovStepDefinition?.microsoftAppType)?.moovStepDefinition.microsoftAppType;
    }

    public isOwner(entityType:string, entityId:number){
        return this.ownerEntityType==entityType && this.ownedByEntityId==entityId;
    }
}